export interface AiSkillProfile {
  readonly drivingDistance: number;
  readonly drivingAccuracy: number;
  readonly ironAccuracy: number;
  readonly wedgeAccuracy: number;
  readonly shortGame: number;
  readonly putting: number;
  readonly recovery: number;
  readonly courseManagement: number;
  readonly shotShaping: number;
  readonly consistency: number;
  readonly aggression: number;
}
export interface AiGolfer {
  readonly id: string;
  readonly name: string;
  readonly skillProfile: AiSkillProfile;
}
export const ALEX_CARTER: AiGolfer = {
  id: 'alex-carter',
  name: 'Alex Carter',
  skillProfile: {
    drivingDistance: 72,
    drivingAccuracy: 70,
    ironAccuracy: 73,
    wedgeAccuracy: 76,
    shortGame: 72,
    putting: 74,
    recovery: 68,
    courseManagement: 76,
    shotShaping: 61,
    consistency: 70,
    aggression: 55,
  },
};
